import ActionType from '../actions/ActionType'
import { omit, last } from 'lodash'
import Fuse from 'fuse.js'
import * as themes from 'components/TemplateForm/themes/index'
import { nanoid } from 'nanoid'
import newEmailHtmlFunc from 'utils/newEmailHtmlFunc'
export default (
  state = {
    bottomNavigation: 0,
    bottomNavigationDisplayed: true,
    templateID: 'new',
    templateTypeSelected: null,
    contactID: null,
    subject: { value: '', initialValue: '' },
    toValue: [],
    body: { value: '', initialValue: '', innerText: '' },
    templatesById: {},
    templateLoadStatus: false,
    scheduledEmailsByID: {},
    scheduledLoadStatus: false,
    templateName: { value: '', initialValue: '' },
    footerValue: '',
    cardSelected: [null],
    snippetsPanelExpanded: true,
    defaultValues: {},
    variablesPanelExpanded: true,
    codeEditorDisplayed: false,
    sections: [],
    sectionSelected: null,
    sectionClicked: null,
    colors: {
      background: '#eeeeee',
      foreground: '#ffffff',
    },
    textAlign: 'center',
    socialMediaLinkValues: {
      facebook: '',
      instagram: '',
      twitter: '',
      color: '#014c94',
    },
    linkValues: {
      text: '',
      url: '',
    },
    buttonValues: {
      text: '',
      url: '',
      backgroundColor: '',
      textColor: '',
    },
    image: {
      width: null,
      height: null,
      fixed: true,
      url: null,
      urlPlaceholder: null,
      alt: null,
      altPlaceholder: null,
      originalDimensions: {
        width: null,
        height: null,
      },
    },
    themeSelected: null,
    defaultValuesModalOpen: false,
  },
  action,
) => {
  switch (action.type) {
    case ActionType.Data.READ_SUCCESS:
      if (action.entityType === 'account/preference') {
        return {
          ...state,
          colors: {
            background: action.payload?.preferences?.email_color_background,
            foreground: action.payload?.preferences?.email_color_foreground,
          },
        }
      }
      return state
    case ActionType.Email.Templates.SELECT_TEMPLATE_TYPE:
      return {
        ...state,
        templateTypeSelected: action?.payload || null,
      }
    case ActionType.Email.Templates.TOGGLE_DEFAULT_VALUES_MODAL:
      const sectionsString =
        last(state.cardSelected) === 'sms'
          ? action?.smsValue
          : state.sections?.reduce((acc, el) => {
              acc += el.value
              return acc
            }, '') || ''

      const newValues = sectionsString
        ?.match(/{{[^{}]+}}/g)
        ?.reduce((acc, el) => {
          const str = el.slice(2, -2).trim()
          if (str) {
            acc[el.slice(2, -2).trim()] = ''
          }
          return acc
        }, {})

      return {
        ...state,
        defaultValuesModalOpen:
          typeof action.payload === 'boolean'
            ? action.payload
            : !state.defaultValuesModalOpen,
        defaultValues: {
          ...(newValues || {}),
          ...state.defaultValues,
        },
      }
    case ActionType.Email.Templates.CHANGE_FIELD_VALUES:
      return {
        ...state,
        [action.fieldType]: {
          ...state[action.fieldType],
          [action.field]: action.payload,
        },
      }
    case ActionType.Email.Templates.SAVE_VALUES:
      return {
        ...state,
        sections: state.sections.map((section, idx) => {
          if (idx !== action.sectionSelected) return section
          if (action.fieldType === 'buttonValues') {
            return {
              ...state.sections[action.sectionSelected],
              value: `<!-- Dynamic WYSIWYG Content --><p><a data-button-text="${
                action.fieldTypeValues.text || 'blank'
              }" data-button-url="${
                action.fieldTypeValues.url || '#'
              }" data-button-color="${
                action.fieldTypeValues.textColor || '#000000'
              }" data-button-background-color="${
                action.fieldTypeValues.backgroundColor || '#efefef'
              }" href="${
                action.fieldTypeValues.url || '#'
              }" target="_blank"><button${
                action.fieldTypeValues.backgroundColor ||
                action.fieldTypeValues.textColor
                  ? ` style="padding: 15px 25px; border: 0px; border-radius: 0.35em; ${
                      action.fieldTypeValues.backgroundColor
                        ? `background-color: ${action.fieldTypeValues.backgroundColor}`
                        : ''
                    }; ${
                      action.fieldTypeValues.textColor
                        ? `color: ${action.fieldTypeValues.textColor}`
                        : ''
                    }"`
                  : ''
              }><strong>${
                action.fieldTypeValues.text || 'blank'
              }</strong></button></a></p><!-- End of Dynamic WYSIWYG Content -->`,
            }
          }
          if (action.fieldType === 'linkValues') {
            return {
              ...state.sections[action.sectionSelected],
              value: `<!-- Dynamic WYSIWYG Content --><a data-link-text="${
                action.fieldTypeValues.text || 'blank'
              }" data-link-url="${action.fieldTypeValues.url || '#'}" href="${
                action.fieldTypeValues.url || '#'
              }" target="_blank">${
                action.fieldTypeValues.text || 'blank'
              }</a><!-- End of Dynamic WYSIWYG Content -->`,
            }
          }
          if (action.fieldType === 'socialMediaLinkValues') {
            return {
              ...state.sections[action.sectionSelected],
              value: `<!-- Dynamic WYSIWYG Content --><table style="margin: 0 auto;" border="0" cellpadding="0" cellspacing="0" width="100%" align="center"><tr><td align="center"><table style="margin: 20px 0 20px 0;"><tr>
  ${
    action.fieldTypeValues.facebook
      ? `<td align="center"><a data-social-background-color="${action.fieldTypeValues.color}" data-social-media="facebook" href="${action.fieldTypeValues.facebook}"><img src="http://vastreach.com/static_assets/facebook.png" border="0" style="padding: 4px; border-radius:28px; background-color: ${action.fieldTypeValues.color};"></a></td>`
      : ''
  }
  ${
    action.fieldTypeValues.instagram
      ? `<td align="center"><a data-social-media="instagram" href="${action.fieldTypeValues.instagram}"><img src="http://vastreach.com/static_assets/instagram.png" border="0" style="padding: 4px; border-radius:28px; background-color: ${action.fieldTypeValues.color};"></a></td>`
      : ''
  }
  ${
    action.fieldTypeValues.twitter
      ? `<td align="center"><a data-social-media="twitter" href="${action.fieldTypeValues.twitter}"><img src="http://vastreach.com/static_assets/twitter.png" border="0" style="padding: 4px; border-radius:28px; background-color: ${action.fieldTypeValues.color};"></a></td>`
      : ''
  }
  </tr></table><!-- End of Dynamic WYSIWYG Content -->`,
            }
          }
          return section
        }),
      }
    case ActionType.Email.SEND_SUCCESS:
      return {
        ...state,
        subject: { value: '', initialValue: '' },
      }
    case ActionType.Email.CLICK_CONTACT_TO_EMAIL:
      return {
        ...state,
        contactID:
          action.payload && action.payload.id ? action.payload.id : null,
        toValue:
          action.payload && action.payload.id
            ? [
                {
                  contactID: action.payload.id,
                  value: action.payload.email,
                  label: `${action.payload.first_name} ${action.payload.last_name}`,
                },
              ]
            : [],
      }
    case ActionType.Email.Templates.HANDLE_SUBJECT_CHANGE:
      return {
        ...state,
        subject: {
          ...state.subject,
          value: action.payload,
        },
      }
    case ActionType.Email.HANDLE_TO_CHANGE:
      return {
        ...state,
        toValue: action.payload.newValue,
      }
    case ActionType.Email.Templates.EMAIL_EDITOR_CHANGE:
      // return {
      //   ...state,
      //   body: {
      //     ...state.body,
      //     value: action.payload.innerHtml,
      //     innerText: action.payload.innerText,
      //   },
      // }
      return typeof action.sectionSelected === 'number'
        ? {
            ...state,
            sections: state.sections.map((section, idx) => {
              if (idx !== action.sectionSelected) return section
              return {
                ...state.sections[action.sectionSelected],
                value: action.payload,
              }
            }),
          }
        : state
    case ActionType.Email.Templates.LIST_REQUEST:
      return {
        ...state,
        templateLoadStatus: 'loading',
      }
    case ActionType.Email.Templates.LIST_SUCCESS:
      return {
        ...state,
        templateLoadStatus: true,
        templatesById:
          (Array.isArray(action.payload) &&
            action.payload.reduce(
              (newTemplatesById, template) => {
                newTemplatesById[template.id] = template
                return newTemplatesById
              },
              { ...state.templatesById },
            )) ||
          state.templatesById,
      }
    case ActionType.Email.Templates.DELETE_SUCCESS:
      return {
        ...state,
        templatesById: omit(state.templatesById, action.payload),
      }
    case ActionType.Email.Templates.CREATE_SUCCESS:
      return {
        ...state,
        templatesById: {
          ...state.templatesById,
          [action.payload.id]: action.payload,
        },
      }
    case ActionType.Email.Templates.UPDATE_REQUEST:
      return {
        ...state,
        templatesById: {
          ...state.templatesById,
          [action.payload.id]: action.payload,
        },
      }
    case ActionType.Email.Templates.LIST_SCHEDULED_REQUEST:
      return {
        ...state,
        scheduledLoadStatus: 'loading',
      }
    case ActionType.Email.Templates.LIST_SCHEDULED_SUCCESS:
      return {
        ...state,
        scheduledLoadStatus: true,
        scheduledEmailsByID:
          (Array.isArray(action.payload) &&
            action.payload.reduce(
              (newScheduledEmailsByID, email) => {
                newScheduledEmailsByID[email.id] = email
                return newScheduledEmailsByID
              },
              { ...state.scheduledEmailsByID },
            )) ||
          state.scheduledEmailsByID,
      }
    case ActionType.Email.Templates.CANCEL_SCHEDULED_REQUEST:
      return {
        ...state,
        scheduledEmailsByID: omit(state.scheduledEmailsByID, action.payload),
      }
    case ActionType.Email.Templates.RECEIVE_TEMPLATE:
      if (action.payload === null) {
        return {
          ...state,
          templateID: 'new',
          templateTypeSelected: null,
          body: {
            value: newEmailHtmlFunc(),
            initialValue: newEmailHtmlFunc(),
            innerText: '',
          },
          subject: { value: '', initialValue: '' },
          templateName: { value: '', initialValue: '' },
          cardSelected: [null],
          snippetsPanelExpanded: true,
          defaultValues: {},
          variablesPanelExpanded: true,
          codeEditorDisplayed: false,
          sections: [],
          sectionSelected: null,
          sectionClicked: null,
          // colors: {
          //   background: '#eeeeee',
          //   foreground: '#ffffff',
          // },
          textAlign: 'center',
          socialMediaLinkValues: {
            facebook: '',
            instagram: '',
            twitter: '',
          },
          themeSelected: null,
        }
      }

      if (action.payload === 'new') {
        return {
          ...state,
          templateID: 'new',
          templateTypeSelected: null,
          body: {
            value: newEmailHtmlFunc(),
            initialValue: newEmailHtmlFunc(),
            innerText: '',
          },
          subject: { value: '', initialValue: '' },
          templateName: { value: '', initialValue: '' },
          // TODO: figure out if cardSelected: [null] isn't here for a reason,
          // and if not then write an initialState()
          snippetsPanelExpanded: true,
          defaultValues: {},
          variablesPanelExpanded: true,
          codeEditorDisplayed: false,
          sections: [],
          sectionSelected: null,
          sectionClicked: null,
          // colors: {
          //   background: '#eeeeee',
          //   foreground: '#ffffff',
          // },
          textAlign: 'center',
          socialMediaLinkValues: {
            facebook: '',
            instagram: '',
            twitter: '',
          },
          themeSelected: null,
        }
      }

      return {
        ...state,
        templateID: action?.payload?.id,
        templateTypeSelected: action?.payload?.type || null,
        body: {
          value: action?.payload?.Template?.HtmlPart || '',
          initialValue: action?.payload?.Template?.HtmlPart || '',
          innerText: action?.payload?.Template?.TextPart || '',
        },
        subject: {
          value: action?.payload?.Template?.SubjectPart || '',
          initialValue: action?.payload?.Template?.SubjectPart || '',
        },
        templateName: {
          value: action?.payload?.name,
          initialValue: action?.payload?.name,
        },
        cardSelected: [
          ...state.cardSelected,
          action?.payload?.type === 'sms' ? 'sms' : 'blank',
        ],
        defaultValues:
          Object.keys(action?.payload?.default_template_values || {}).length ===
            1 &&
          Object.keys(action?.payload?.default_template_values || {})[0] === ''
            ? {}
            : action?.payload?.default_template_values,
      }
    case ActionType.Email.Templates.HANDLE_TEMPLATE_NAME_CHANGE:
      return {
        ...state,
        templateName: {
          ...state.templateName,
          value: action.payload,
        },
      }
    case ActionType.Email.Templates.READ_FOOTER_SUCCESS:
      return {
        ...state,
        footerValue: action.payload.footer.html,
      }
    case ActionType.Email.Templates.READ_SUCCESS:
      return {
        ...state,
        templatesById: {
          ...state.templatesById,
          [action.payload.id]: action.payload,
        },
      }
    case ActionType.Email.Templates.SELECT_EMAIL_CARD:
      return {
        ...state,
        cardSelected: [...state.cardSelected, action.payload],
      }
    case ActionType.Email.Templates.BACK_BUTTON:
      let newState = state.cardSelected
      newState.pop()
      return {
        ...state,
        cardSelected: newState,
      }
    case ActionType.Email.Templates.SELECT_THEME:
      return {
        ...state,
        body: {
          ...state.body,
          value: (action.payload && action.payload.value) || '',
        },
        // themeSelected: action.payload || null,
      }
    case ActionType.Email.Templates.READ_THEME_FROM_HTML:
      return {
        ...state,
        themeSelected: action.payload,
      }
    case ActionType.LUIS.GET_SUCCESS:
      const intent = action.payload.body.topScoringIntent.intent
      const entities = action.payload.body.entities
      let value = state.body.value
      let cardSelected = state.cardSelected
      if (intent === 'Send Email' && entities.length) {
        entities.forEach(entity => {
          if (entity.type === 'THEME') {
            const values = Object.values(themes)
            const fuse = new Fuse(values, {
              shouldSort: true,
              threshold: 0.6,
              location: 0,
              distance: 100,
              maxPatternLength: 32,
              minMatchCharLength: 1,
              keys: ['text'],
            })
            let results = fuse.search(entity.entity)

            if (results.length) {
              value = results[0].value
              cardSelected = [...state.cardSelected, 'blank']
            }
          }
        })
      }
      return {
        ...state,
        body: {
          ...state.body,
          value,
          initialValue: value,
        },
        cardSelected,
      }
    case ActionType.Email.Templates.TOGGLE_SNIPPETS_PANEL:
      return {
        ...state,
        snippetsPanelExpanded: !state.snippetsPanelExpanded,
      }
    case ActionType.Email.Templates.PASTE_SNIPPET:
      // if (action.payload && action.payload.idx !== null) {
      //   return {
      //     ...state,
      //     // body: {
      //     //   ...state.body,
      //     //   value: action.payload.innerHtml,
      //     // },
      //     sections: state.sections.map((section, idx) => {
      //       if (idx !== action.payload.idx) return section
      //       return action.payload.tag
      //     }),
      //   }
      // }

      return {
        ...state,
        // body: {
        //   ...state.body,
        //   value: action.payload.innerHtml,
        // },
        sections: [
          ...state.sections,
          {
            id: nanoid(),
            idx: state.sections.length,
            value: action.payload.html,
            editor: action.payload.editor,
          },
        ],
      }
    case ActionType.Email.Templates.REMOVE_SECTION:
      return {
        ...state,
        sections: state.sections
          .filter((section, idx) => idx !== action.payload)
          .map((section, idx) => ({ ...section, idx })),
        sectionSelected: null,
        sectionClicked: null,
      }
    case ActionType.Email.Templates.TOGGLE_VARIABLES_PANEL:
      return {
        ...state,
        variablesPanelExpanded: !state.variablesPanelExpanded,
      }
    case ActionType.Email.Templates.DEFAULT_VALUE_CHANGE:
      return {
        ...state,
        defaultValues: {
          ...state.defaultValues,
          [action.payload.defaultValue]: action.payload.value,
        },
      }
    case ActionType.Email.Templates.PASTE_TAG:
      if (!state.defaultValues[action.payload.tag.slice(3, -3)]) {
        console.log('hits first if')
        return {
          ...state,
          // sections: state.sections.map((section, idx) => {
          // 	if (idx !== action.sectionSelected) {
          // 		console.log(idx)
          // 		console.log(action.sectionSelected)
          // 		console.log(idx !== action.sectionSelected)
          // 		console.log('is not the index')
          // 		return section
          // 	}
          // 	console.log('is the index')
          // 	console.log(state.sections[action.sectionSelected].value)
          // 	console.log(
          // 		`${state.sections[action.sectionSelected].value} ${
          // 			action.payload.tag
          // 		}`,
          // 	)

          // 	return {
          // 		...state.sections[action.sectionSelected],
          // 		value: `${state.sections[action.sectionSelected].value} ${
          // 			action.payload.tag
          // 		}`,
          // 	}
          // }),
          defaultValues: {
            ...state.defaultValues,
            [`${action.payload.tag.slice(3, -3)}`]: '',
          },
        }
      }
      return state
    // return {
    // 	...state,
    // 	sections: state.sections.map((section, idx) => {
    // 		if (idx !== action.sectionSelected) return section
    // 		return {
    // 			...state.sections[action.sectionSelected],
    // 			value: `${state.sections[action.sectionSelected].value} ${
    // 				action.payload.tag
    // 			}`,
    // 		}
    // 	}),
    // }
    case ActionType.Email.Templates.CODE_EDITOR_CHANGE:
      return typeof action.sectionSelected === 'number'
        ? {
            ...state,
            // body: {
            //   ...state.body,
            //   value: action.payload.innerHtml,
            // },
            sections: state.sections.map((section, idx) => {
              if (idx !== action.sectionSelected) return section
              return {
                ...state.sections[action.sectionSelected],
                value: action.payload,
              }
            }),
          }
        : state
    case ActionType.Email.Templates.CLICK_CODE_BUTTON:
      return {
        ...state,
        codeEditorDisplayed: !state.codeEditorDisplayed,
      }
    case ActionType.Tasks.RECEIVE_TASK:
      if (action.payload) {
        if (action.payload.send_email) {
          const templateID = action.payload.send_email.trigger_data.template_id
          const template = action.templatesByID[templateID]
          return {
            ...state,
            templateID,
            body: {
              value: template.Template.HtmlPart,
              initialValue: template.Template.HtmlPart,
              innerText: template.Template.TextPart,
            },
            subject: {
              value: template.Template.SubjectPart,
              initialValue: template.Template.SubjectPart,
            },
            templateName: {
              value: template.name,
              initialValue: template.name,
            },
            cardSelected: [...state.cardSelected, 'blank'],
            defaultValues:
              action.payload.send_email.trigger_data.default_template_values ||
              {},
            codeEditorDisplayed: false,
          }
        }

        if (action?.payload?.send_sms?.trigger_data?.template_id) {
          return {
            ...state,
            templateID: action?.payload?.send_sms?.trigger_data?.template_id,
            defaultValues:
              action.payload.send_sms.trigger_data.default_template_values ||
              {},
          }
        }

        return state
      }

      return {
        ...state,
        body: { value: '', initialValue: '', innerText: '' },
        sections: [],
        templateID: 'new',
        subject: { value: '', initialValue: '' },
        templateName: { value: '', initialValue: '' },
        cardSelected: [null],
        defaultValues: {},
        themeSelected: null,
      }
    case ActionType.Email.Templates.CLICK_BOTTOM_NAVIGATION:
      return {
        ...state,
        bottomNavigation: action.payload,
      }
    case ActionType.Email.Templates.TOGGLE_COLLAPSE:
      return {
        ...state,
        bottomNavigationDisplayed: !state.bottomNavigationDisplayed,
      }
    case ActionType.Email.Templates.SET_SECTIONS:
      return {
        ...state,
        sectionSelected: null,
        sectionClicked: null,
        sections: Array.isArray(action.payload)
          ? action.payload.map((section, index) => ({
              ...section,
              /* value: '<div>test</div>', */ index,
            }))
          : state.sections,
      }
    // case ActionType.Email.Templates.SET_SECTIONS:
    // 	const dragObj = state.sections[action.payload.dragIndex]

    // 	return {
    // 		...state,
    // 		sections: update(state.sections, {
    // 			$splice: [
    // 				[action.payload.dragIndex, 1],
    // 				[action.payload.hoverIndex, 0, dragObj],
    // 			],
    // 		}),
    // 	}
    case ActionType.Email.Templates.CLICK_SECTION:
      return {
        ...state,
        sectionClicked:
          typeof action.payload === 'number' ? action.payload : null,
      }
    case ActionType.Email.Templates.SELECT_SECTION:
      var doc =
        action.section &&
        action.section.value &&
        new DOMParser().parseFromString(action.section.value, 'text/html')

      const aTagArray =
        doc &&
        doc.getElementsByTagName &&
        doc.getElementsByTagName('a') &&
        doc.getElementsByTagName('a').length &&
        Array.from(doc.getElementsByTagName('a'))

      if (aTagArray) {
        const socialMediaObj = aTagArray.reduce((acc, el) => {
          if (
            el.attributes &&
            el.attributes['data-social-media'] &&
            el.attributes.href
          ) {
            acc[el.attributes['data-social-media'].value] =
              el.attributes.href.value
          }

          if (el.attributes && el.attributes['data-social-background-color']) {
            acc.color = el.attributes['data-social-background-color'].value
          }
          return acc
        }, {})

        const linkValuesObj = aTagArray.reduce((acc, el) => {
          if (el.attributes && el.attributes['data-link-text']) {
            acc.text = el.attributes['data-link-text'].value
          }
          if (el.attributes && el.attributes['data-link-url']) {
            acc.url = el.attributes['data-link-url'].value
          }
          return acc
        }, {})

        const buttonValuesObj = aTagArray.reduce((acc, el) => {
          if (el.attributes && el.attributes['data-button-text']) {
            acc.text = el.attributes['data-button-text'].value
          }
          if (el.attributes && el.attributes['data-button-url']) {
            acc.url = el.attributes['data-button-url'].value
          }
          if (el.attributes && el.attributes['data-button-color']) {
            acc.textColor = el.attributes['data-button-color'].value
          }
          if (el.attributes && el.attributes['data-button-background-color']) {
            acc.backgroundColor =
              el.attributes['data-button-background-color'].value
          }
          return acc
        }, {})

        return {
          ...state,
          codeEditorDisplayed: false,
          sectionSelected: action.payload,
          socialMediaLinkValues: {
            ...state.socialMediaLinkValues,
            ...socialMediaObj,
          },
          linkValues: {
            ...state.linkValues,
            ...linkValuesObj,
          },
          buttonValues: {
            ...state.buttonValues,
            ...buttonValuesObj,
          },
        }
      }

      if (
        action.image &&
        action.image.width &&
        action.image.height &&
        action.image.url
      ) {
        return {
          ...state,
          codeEditorDisplayed: false,
          sectionSelected: action.payload,
          image: {
            ...state.image,
            alt: action.image.alt,
            altPlaceholder: action.image.alt,
            height: action.image.height,
            width: action.image.width,
            url: action.image.url,
            urlPlaceholder: action.image.url,
            originalDimensions: {
              height: action.image.height,
              width: action.image.width,
            },
          },
        }
      }

      return {
        ...state,
        codeEditorDisplayed: false,
        sectionSelected: action.payload,
      }
    case ActionType.Email.Templates.SET_IMAGE:
      return {
        ...state,
        sectionSelected: null,
        sectionClicked: null,
        sections: state.sections.map((section, idx) => {
          if (idx !== state.sectionSelected) {
            return section
          }
          return {
            ...section,
            value: `<!-- Dynamic WYSIWYG Content --><table style="width: 100%;max-width: 600px;margin: 0 auto 0;padding: 0;text-align: center;background: #ffffff;"><tbody><tr><td><img src="${state.image.urlPlaceholder}" data-vast-reach-dimensions-in-px="${state.image.width} ${state.image.height}" width="${state.image.width}px" height="${state.image.height}px" alt="${state.image.altPlaceholder}" style="max-width: 100%;margin: 0 auto;display: block;"></td></tr></tbody></table><!-- End of Dynamic WYSIWYG Content -->`,
          }
        }),
        image: {
          alt: null,
          altPlaceholder: null,
          width: null,
          height: null,
          fixed: true,
          url: null,
          urlPlaceholder: null,
        },
      }
    case ActionType.Email.Templates.SET_IMAGE_URL:
      const { width, height } = action
      const newWidth = width > 600 ? '600' : `${width}`
      const newHeight =
        width > 600
          ? Math.floor((600 * parseInt(height)) / parseInt(width)).toString()
          : `${height}`

      return {
        ...state,
        sections: state.sections.map((section, idx) => {
          if (idx !== action.sectionSelected) {
            return section
          }
          return {
            ...section,
            value: `<!-- Dynamic WYSIWYG Content --> <table style="width: 100%;max-width: 600px;margin: 0 auto 0;padding: 0;text-align: center;background: transparent;"><tbody><tr><td><img src="${
              action.payload
            }" alt="${
              action?.label || 'an image'
            }" data-vast-reach-dimensions-in-px="${newWidth} ${newHeight}" height="${newHeight}px" width="${newWidth}px" style="max-width: 100%;margin: 0 auto;display: block;"> </td> </tr> </tbody></table> <!-- End of Dynamic WYSIWYG Content -->`,
          }
        }),
        image: {
          ...state.image,
          url: action.payload,
          urlPlaceholder: action.payload,
          width: newWidth,
          height: newHeight,
          originalDimensions: {
            width: newWidth,
            height: newHeight,
          },
        },
      }
    case 'set-image-prop':
      return {
        ...state,
        image: {
          ...state.image,
          [action.payload?.prop]: action.payload?.value,
        },
      }
    case ActionType.Email.Templates.SET_BACKGROUND:
      return {
        ...state,
        colors: {
          foreground: action?.payload?.foreground || state.colors.foreground,
          background: action?.payload?.background || state.colors.background,
        },
      }
    case ActionType.Email.Templates.SET_TEXT_ALIGN:
      return {
        ...state,
        textAlign: action.payload || 'center',
      }
    case ActionType.Inbox.REPLY_TO_EMAIL:
      return {
        ...state,
        subject: {
          ...state.subject,
          value:
            action.payload && action.payload.subject
              ? action.payload.subject.slice(0, 3) === 'Re:'
                ? action.payload.subject
                : `Re: ${action.payload.subject}`
              : '',
        },
      }
    case ActionType.Inbox.SELECT_CONVERSATION:
      return {
        ...state,
        subject: {
          value: '',
          initialValue: '',
        },
      }
    case ActionType.Email.Templates.CHANGE_TEMPLATE_ID:
      return {
        ...state,
        templateID: action.payload || 'new',
      }
    case ActionType.Email.Templates.SET_IMAGE_DIMENSION:
      if (
        action.payload &&
        action.payload.type &&
        typeof action.payload.value !== 'undefined'
      ) {
        const { type, value } = action.payload

        if (state.image.fixed && typeof value === 'string') {
          const otherType = type === 'height' ? 'width' : 'height'

          const oldDimension = parseInt(state.image.originalDimensions[type])
          const newDimension = parseInt(value)
          const ratio = newDimension ? oldDimension / newDimension : 0

          const oldOtherDimension = parseInt(
            state.image.originalDimensions[otherType],
          )
          let newOtherDimension = ratio
            ? Math.floor(oldOtherDimension / ratio)
            : 0

          const otherValue = newOtherDimension.toString()

          if (otherType === 'width' && newOtherDimension > 600) {
            return {
              ...state,
              image: {
                ...state.image,
                width: '600',
                height: Math.floor(
                  (600 * parseInt(state.image.originalDimensions.height)) /
                    parseInt(state.image.originalDimensions.width),
                ).toString(),
              },
            }
          }

          return {
            ...state,
            image: {
              ...state.image,
              [type]: value,
              [otherType]: otherValue,
            },
          }
        }

        return {
          ...state,
          image: {
            ...state.image,
            [type]: value,
          },
        }
      }
      return state
    case ActionType.Email.Templates.SET_IMAGE_SIZE:
      return {
        ...state,
        sectionSelected: null,
        sectionClicked: null,
        sections: state.sections.map((section, idx) => {
          if (idx !== action.sectionSelected) {
            return section
          }
          return {
            ...section,
            value: `<!-- Dynamic WYSIWYG Content --><table style="width: 100%;max-width: 600px;margin: 0 auto 0;padding: 0;text-align: center;background: #ffffff;"><tbody><tr><td><img src="${state.image.url}" data-vast-reach-dimensions-in-px="${state.image.width} ${state.image.height}" width="${state.image.width}px" height="${state.image.height}px" alt="${state.image.alt}" style="max-width: 100%;margin: 0 auto;display: block;"></td></tr></tbody></table><!-- End of Dynamic WYSIWYG Content -->`,
          }
        }),
        image: {
          alt: null,
          altPlaceholder: null,
          width: null,
          height: null,
          fixed: true,
          url: null,
          urlPlaceholder: null,
        },
      }
    default:
      return state
  }
}
